import * as Yup from 'yup'

export const userSchema = Yup.object({
    firstname: Yup.string().min(2).max(50).required("Please enter your first name"),
    lastname:Yup.string().min(2).max(50).required("Please enter your last name"),
    email: Yup.string().email().min(2).max(50).required("Please enter your email"),
})